import { liveUsageMgmtSliceSelector } from "../store-selectors/liveUsageMgmtSliceSelector";
import { AppliedFilterType } from "../../liveUsageMgmtSlice";
import { RootState } from "@/store/store";

export const liveUsageMgmtAppliedFiltersSelector = (
  state: RootState,
): AppliedFilterType =>
  liveUsageMgmtSliceSelector(state).filters.appliedFilters;
